import * as React from 'react';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { AgendaMeetingListingView } from '../features/activities/common/AgendaMeetingListingView';

export default function AnnualWorkgroupStatusListingPage(): JSX.Element 
{
	return (
		<ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="annualworkgroupstatus">
            <AgendaMeetingListingView
                headerIcon='interface_glyph_comment'
                pageHeader='Årlige drøftelser'
                createNewButtonText='Opret ny årlig drøftelse'
                currentActivitiesHeader='Aktuelle årlige drøftelser'
                pastActivitiesHeader='TIDLIGERE ÅRLIGE DRØFTELSER'
                type='AnnualWorkgroupStatus' />
		</ProtectedPageWrapper>
	);
}
